export default __webpack_public_path__ + "static/media/fileIcon.d12da224.svg";